
define('modules/application/wizard/steps/systemChoices',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "./regularStep",
  "../../popup"
],

function(app, Backbone, jQueryUi, RegularStep, Popup) {

  var stepValidationPopup = Popup.View.extend({
    className:  "popup message",
    template :  "application/popups/message"
  });

  //Defining child content view
  var systemChoices            = _.extend({}, RegularStep);
  var systemChoicesContentView = systemChoices.Views.Content.extend({

    isValid              : function() {
      if ((BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))&&(this.model.get("mainControlUnitId")))
        return true;
      else
        return false;
    },

    initialize            : function()  {
      var that            = this,
          sections        = this.options.model.get("sections"), sectionsLength = sections ? sections.length : 0,
          classToInstance,
          obj;

      //Bind on accessory line selection
      window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', function(accessoryLineId)  {
        that.model.set("accessoryLineId",BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
      });

      //Bind on accessory line removal
      window.BticinoS4B.eventAggregator.bind('accessoryLine:removed', function()      {
        that.model.set("accessoryLineId", undefined);
      });

      this.addValidationHandlers();

      //Bind on confirm button click
      this.model               = this.options.model;
      for(var i=0; i<sectionsLength ;i++)
      {
        //Instancing the section's classes
        classToInstance = this.sectionInstancer(sections[i]);
        obj   = classToInstance;

        //Instancing the section model
        if (sections[i].idWizardChoice)
          objModel  = new obj.Model({stepEventAggregator :   this.options.stepEventAggregator, idWizardChoice : sections[i].idWizardChoice});
        else
          objModel  = new obj.Model({stepEventAggregator :   this.options.stepEventAggregator});

        //Inserting section's views into the main accordio view
        this.insertView(".accordionView", new obj.Views.titleBar ({ model   :   objModel  }));
        this.insertView(".accordionView", new obj.Views.content  ({ model   :   objModel  }));
      }
    },

    afterRender : function() {
      var pageContent     = $(this.el).find(".itemView");
      var confirmSection  = $(this.el).find("footer");

      if(confirmSection.length)
        pageContent.css("height", (this.$el.height()-confirmSection.height())+"px");
      else
        pageContent.css("height", this.$el.height()+"px");

      $(this.el).find("h3 .titleBarcontent span").corner("2px");
      $(this.el).find(".accordionView").accordion({collapsible: true, active: 0, autoHeight: false });
      //$(this.el).find(".accordionView").mCustomScrollbar({advanced:{updateOnContentResize: true}});
    }
  });

  //Creating final systemChoices class
  _.extend({}, systemChoices, {
    objClass    : "systemChoices",
    Views       : _.extend(systemChoices.Views, {Content : systemChoicesContentView})
  });

  // Required, return the module for AMD compliance
  return systemChoices;

});